
import axios from "axios";
import { logoutAndRedirect, refreshToken } from "./utils/tokenUtils";

const backendUrl = window._env_?.REACT_APP_BACKEND_URL;


const api = axios.create({
    baseURL: backendUrl,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("authToken");
        if (token && !config.url?.includes("refreshAccessToken")) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        const status = error.response?.status;


        if (originalRequest.url?.includes('/api/auth/login')) {
            return Promise.reject(error);
        }

        if (status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const newToken = await refreshToken();
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return api(originalRequest);
            } catch (refreshError) {
                return Promise.reject(refreshError);
            }
        }

        if (status === 403) {
            console.warn("🔐 Forbidden! Logging out...");
            logoutAndRedirect("unauthorized");
        }

        return Promise.reject(error);
    }
);

export default api;